import PropTypes from 'prop-types';
import { awaitRequests, promise } from '../../../helpers';
import { firebaseUpdate } from '../firebase';
import { updateProfileManagementRelations } from '../general';
import { updateCoursesLicensesBy } from '../courses-licenses';
import {
    getRegionalEntities,
    sendRegionalEntityManagersInvitations,
    updateRegionalEntityManagers,
    updateRegionalEntityRelations,
} from './index';

const updateRegionalEntity = ({ data, docId, where, managers, prevManagers, coursesLicenses }) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        // -- update
        const update = (d, id) => dispatch(firebaseUpdate({ collection: 'regionalEntities', docId: id, data: d }));

        // -- after update
        const afterUpdate = item => {
            const reqs = [];

            // update managers name in collections
            reqs.push(dispatch(updateRegionalEntityManagers(item.id, managers)));

            // update regional entity name in collections
            reqs.push(dispatch(updateRegionalEntityRelations(data, docId)));

            // update licenses availability usage
            reqs.push(dispatch(updateCoursesLicensesBy({ by: 'regional-entity', regionalEntityId: item.id, coursesLicenses })));

            // update managers profileId assignations inside collections
            if (managers && managers.length) {
                reqs.push(
                    awaitRequests(
                        managers.map(manager =>
                            dispatch(
                                updateProfileManagementRelations({
                                    email: manager.email,
                                }),
                            ),
                        ),
                    ),
                );
            }

            return awaitRequests(reqs).then(res => {
                const updatedManagers = (res && res[0]) || {};
                const { managersSaved } = updatedManagers;

                // send email invitations
                return dispatch(sendRegionalEntityManagersInvitations(item, managers, prevManagers)).then(() => {
                    return promise({ item, managersSaved });
                });
            });
        };

        // -- single update
        if (data && docId) {
            return update(data, docId).then(updatedItem => afterUpdate(updatedItem));
        }

        // -- multiple update
        if (where && data) {
            return dispatch(getRegionalEntities({ where })).then(items => {
                return awaitRequests(items.map(item => update(data, item.id).then(updatedItem => afterUpdate(updatedItem))));
            });
        }

        return promise({ item: undefined, managersSaved: [] });
    };
};

updateRegionalEntity.propTypes = {
    managers: PropTypes.array,
    prevManagers: PropTypes.array,
};

updateRegionalEntity.defaultProps = {
    managers: [],
    prevManagers: [],
};

export default updateRegionalEntity;
